import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { TypologyItemMaintenanceDto } from './TypologyItemMaintenanceDto';
import { TypologyListMaintenanceDto } from './TypologyListMaintenanceDto';

@Injectable()
export class TypologyMaintenanceController extends BaseMaintenanceController<TypologyListMaintenanceDto, TypologyItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "typology");
    }

    public getResourceRoot(): string {
        return "TYPOLOGY";
    }

    public buildUrl(uri: string): string {
        return "system/dataandparameters/typology" + uri;
    }
}